<template>
	<div class="message">
		<p>You need to connect your Metamask Wallet.</p>
		<a
			class="button_basic connect_wallet"
			href="#"
			@click.prevent="connectWallet">
			<img
				:src="require('@/assets/images/connect_wallet_button_text_web.png')"
				class="no_lazy"
				alt="">
		</a>
		<p
			v-if="loading"
			class="loader">
			<img
				:src="require('@/assets/images/presale_open_bulldroids.gif')"
				class="no_lazy"
				alt="">
		</p>
		<p
			v-if="error"
			class="error">
			Error: {{ error }}
		</p>
	</div>
</template>

<script setup>
import { useWallet } from '@/composables/wallet';

const {
	loading,
	error,

	connectWallet,
} = useWallet();
</script>
